"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StarRating = exports.Root = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1)
}));
const StarRating = exports.StarRating = (0, _mui.styled)(_components.StarRating)(() => ({
  fontSize: '1.4rem',
  [`.${_components.starRatingClasses.star}`]: {
    margin: '0 -3px'
  }
}));
